(function ($) {
  'use strict';
  
  function fauxSelect(fauxDocSelect) {
    $(fauxDocSelect).each(function () {
      var $selectWrap = $(this),
        $expander = $selectWrap.children('a'),
        $expandable = $expander.siblings('ul'),
        $expandableChildren = $expandable.children();

      if ($expandableChildren.length <= 0) {
        $selectWrap.hide();
      }

      $expander.on('click', function (e) {
        e.preventDefault();

        if ($selectWrap.hasClass('opened')) {
          $('body').off('click', fauxSelectHandler);
          $expandable.off('keydown', keyboardSelect);
          $expandable.slideUp(function () {
            $selectWrap.removeClass('opened');
          });
        } else {
          $('.faux-select.opened').children('a').trigger('click');

          $selectWrap.addClass('opened');
          $expandable.slideDown(function () {
            $expandable.find('a').attr('tabIndex', -1);
            //$expandable.find("li:first-child").attr("tabIndex", 0).focus();
            $expandable.on('keydown', keyboardSelect);
          });
          $('body').on('click', fauxSelectHandler);
        }

        $expandableChildren.on('click', function (e) {
          e.preventDefault();
          $expandableChildren.removeClass('selected');
          $(this).addClass('selected');
          $expander.find('.value').text($(this).text());

          $('body').off('click', fauxSelectHandler);

          $expandable.off('keydown', keyboardSelect);

          $expandable.slideUp(function () {
            $selectWrap.removeClass('opened');
          });
        });
      });

      function keyboardSelect(event) {
        if (event.keyCode !== 27 && event.keyCode !== 9) {
          var $currItem = $(document.activeElement).parent(),
            idx = $currItem.index(),
            $anchor;

          $(event.target).attr('tabIndex', -1);

          // decide what do do based on the keyCode
          event.preventDefault();

          switch (event.keyCode) {
            // move to previous item
            case 37: // left
            case 38: // up
              if ($currItem.prev().length >= 0) {
                $anchor = $expandable.find('li:eq(' + (idx - 1) + ') a');
              } else {
                $anchor = $expandable.find('li:last-child a');
              }
              break;
            // move to next item
            case 39: // right
            case 40: // down
              if ($currItem.next().length >= 0) {
                $anchor = $expandable.find('li:eq(' + (idx + 1) + ') a');
              } else {
                $anchor = $expandable.find('li:first-child a');
              }
              break;
            // go to the beginning of the list
            case 33: // page up
            case 36: // home
              $anchor = $expandable.find('li:first-child a');
              break;
            // go to the end of the list
            case 34: // page down
            case 35: // end
              $anchor = $expandable.find('li:last-child a');
              break;
          }
          if ($anchor) {
            $currItem.attr('tabIndex', -1);
            $anchor.attr('tabIndex', 0).focus();
          }
        } else {
          if (event.keyCode === 27) {
            $expander.focus();
          }
          $expander.trigger('click');
        }
      }

      function fauxSelectHandler(e) {
        if ($(e.target).parents('.faux-select').length <= 0 && e.originalEvent) {
          $('.faux-select.opened').children('a').trigger('click');
          $('body').off('click', fauxSelectHandler);
        }
      }
    });
  }
  
  window.fauxSelect = fauxSelect;
  
  if ($ && $.fn) {
    $.fn.fauxSelect = function() {
      fauxSelect(this);
      return this;
    };
  }
  
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = fauxSelect;
  }
  
  if (typeof define === 'function' && define.amd) {
    define(function() { return fauxSelect; });
  }
})(typeof jQuery !== 'undefined' ? jQuery : undefined);

export default window.fauxSelect;
